// extracted by mini-css-extract-plugin
module.exports = {"paragraphLine":"style-module--paragraphLine--1h8bz"};